import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Item} from '../transactions';
import Loader from "./Loader";
import {pageTransition} from "../../dashboardNew/functions/pageTransition";

class AddToBasketModal extends Component {

    closeModal() {
        const elem = document.querySelector('#addToBasket');
        const elemBack = document.querySelector('.modal-backdrop');
        elem.remove();
        elemBack.remove();
        pageTransition('/basket')
    }

    render() {
        const {product, addToBasket} = this.props;

        if (!product || product === undefined) {
            return <Loader />
        }

        return (

            <div id="addToBasket" className="popup-basket modal fade in liam" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close close-popup" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <Item 
                                id={ product.id }
                                purchased={ product.in_basket }
                                item={ product }
                                onAddToCartClicked={ () => addToBasket(product.id) }
                                closeModal={this.closeModal} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

AddToBasketModal.propTypes = {
    addToBasket: PropTypes.func.isRequired,
};

export default AddToBasketModal;


// WEBPACK FOOTER //
// src/client/components/common/elements/AddToBasketModal.js